module.exports = __webpack_public_path__ + "img/ejournal-group-picture.22106e52.jpg";